import React, { ElementType } from 'react';
import { Typography } from '../../../../../../wag-react/components/Typography';
import { Flex } from '../../../../../../wag-react/next-components/Flex';
export type TrainingOverviewTabProps = {
  Icon: ElementType;
  text: string;
};
export const TrainingOverviewTab = ({
  Icon,
  text
}: TrainingOverviewTabProps) => <Flex alignItems="center" flex={1} justifyContent="center" data-sentry-element="Flex" data-sentry-component="TrainingOverviewTab" data-sentry-source-file="index.tsx">
    <Icon data-sentry-element="Icon" data-sentry-source-file="index.tsx" />
    <Typography variant="body2" ml={1} py={2} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
      {text}
    </Typography>
  </Flex>;